import { gql } from "apollo-boost"

export const UPDATE_ACTIVITIES = gql`
  mutation updateActivities ($activities: [CreateActivityInput!]!) {
    updateActivities(activities: $activities) {
      id
    }
  }
`
